var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-container" },
    [
      _c(
        "a",
        {
          staticStyle: {
            color: "#409eff",
            "font-weight": "bold",
            "text-decoration": "none",
            cursor: "pointer",
            display: "flex",
            "justify-content": "center",
          },
          attrs: { href: "javascript:void(0)" },
          on: {
            click: function ($event) {
              _vm.dialogVisible = true
            },
          },
        },
        [
          _c("svg-icon", {
            staticStyle: {
              width: "2em !important",
              height: "1.5em !important",
            },
            attrs: { "icon-class": "icons8-camera-48" },
          }),
          _vm._v(" AI 護照匯入 "),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.dialogVisible,
            fullscreen: "",
            modal: false,
            "show-close": false,
            "custom-class": "fullscreen-passport-dialog",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            opened: _vm.initCamera,
            close: _vm.stopCamera,
          },
        },
        [
          _c("div", { staticClass: "passport-recognition-container" }, [
            _c("header", { staticClass: "app-header" }, [
              _c("div", { staticClass: "logo-area" }, [
                _c("span", { staticClass: "logo-icon" }, [
                  _c("img", {
                    staticStyle: { width: "30px" },
                    attrs: {
                      src: require("@/assets/images/logo3gtapp_new_20260710.png"),
                    },
                  }),
                ]),
                _c("div", { staticClass: "logo-text-area" }, [
                  _c(
                    "div",
                    {
                      staticClass: "logo-text",
                      staticStyle: { "font-size": "1rem" },
                    },
                    [_vm._v("AI Passport Recognition System")]
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "logo-text",
                      staticStyle: { "font-size": "1rem" },
                    },
                    [_vm._v(_vm._s(_vm.tourGroupNo))]
                  ),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "main-content" }, [
              _c("div", { staticClass: "camera-section" }, [
                _c("video", {
                  ref: "video",
                  staticClass: "video-stream",
                  attrs: { autoplay: "", playsinline: "" },
                }),
                _c("canvas", {
                  ref: "canvas",
                  staticStyle: { display: "none" },
                }),
              ]),
              _c("div", { staticClass: "control-section" }, [
                _c(
                  "button",
                  {
                    staticClass: "capture-btn",
                    attrs: { disabled: _vm.loading },
                    on: { click: _vm.takePhoto },
                  },
                  [_c("div", { staticClass: "inner-circle" })]
                ),
              ]),
              _c(
                "div",
                { staticClass: "table-section" },
                [
                  _c(
                    "el-table",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.loading,
                          expression: "loading",
                        },
                      ],
                      staticStyle: { width: "100%" },
                      attrs: {
                        data: _vm.tableData,
                        border: "",
                        stripe: "",
                        height: "100%",
                        "header-cell-style": {
                          background: "#f5f7fa",
                          color: "#606266",
                          textAlign: "center",
                        },
                        "cell-style": { textAlign: "center" },
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          prop: "name",
                          label: "姓名",
                          "min-width": "130",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("el-input", {
                                  staticClass: "edit-input",
                                  attrs: {
                                    size: "small",
                                    placeholder: "請輸入姓名",
                                  },
                                  model: {
                                    value: scope.row.name,
                                    callback: function ($$v) {
                                      _vm.$set(scope.row, "name", $$v)
                                    },
                                    expression: "scope.row.name",
                                  },
                                }),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "birthday",
                          label: "生日",
                          "min-width": "160",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("el-date-picker", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    size: "small",
                                    type: "date",
                                    "value-format": "yyyy-MM-dd",
                                    placeholder: "選擇生日",
                                  },
                                  model: {
                                    value: scope.row.birthday,
                                    callback: function ($$v) {
                                      _vm.$set(scope.row, "birthday", $$v)
                                    },
                                    expression: "scope.row.birthday",
                                  },
                                }),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "idNumber",
                          label: "身分證字號",
                          "min-width": "160",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("el-input", {
                                  staticClass: "edit-input",
                                  attrs: {
                                    size: "small",
                                    placeholder: "請輸入身分證",
                                  },
                                  model: {
                                    value: scope.row.idNumber,
                                    callback: function ($$v) {
                                      _vm.$set(scope.row, "idNumber", $$v)
                                    },
                                    expression: "scope.row.idNumber",
                                  },
                                }),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "passportNumber",
                          label: "護照號碼",
                          "min-width": "160",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("el-input", {
                                  staticClass: "edit-input",
                                  attrs: {
                                    size: "small",
                                    placeholder: "請輸入護照號碼",
                                  },
                                  model: {
                                    value: scope.row.passportNumber,
                                    callback: function ($$v) {
                                      _vm.$set(scope.row, "passportNumber", $$v)
                                    },
                                    expression: "scope.row.passportNumber",
                                  },
                                }),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: { label: "操作", width: "80" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("el-button", {
                                  attrs: {
                                    type: "danger",
                                    icon: "el-icon-minus",
                                    circle: "",
                                    size: "mini",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleDelete(scope.$index)
                                    },
                                  },
                                }),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
            _c(
              "footer",
              { staticClass: "action-footer" },
              [
                _c(
                  "el-button",
                  {
                    staticClass: "btn-import",
                    attrs: {
                      type: "danger",
                      loading: _vm.loading,
                      disabled: !_vm.tableData || _vm.tableData.length <= 0,
                    },
                    on: { click: _vm.handleImport },
                  },
                  [_vm._v(" 匯入系統 ")]
                ),
                _c(
                  "el-button",
                  {
                    staticClass: "btn-leave",
                    attrs: { type: "info" },
                    on: { click: _vm.handleLeave },
                  },
                  [_vm._v(" 離開頁面 ")]
                ),
              ],
              1
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }